import initState from "./initState";

import { updateObject, deepClone } from "utils";
import * as types from "./types";

function fetchAppLogsStart(state) {
  return updateObject(state, {
    loading: true
  });
}

function fetchAppLogsSuccess(state, action) {
  return updateObject(state, {
    loading: false,
    list: [...action.logs]
  });
}

function fetchAppLogsFailure(state, action) {
  return updateObject(state, {
    loading: false,
    failed: {
      msg: action.data.msg,
      status: action.data.status
    }
  });
}

function fetchCFRLogsURLStart(state, action) {
  const updatedLogsList = [...state.list];
  updatedLogsList[action.index] = {
    ...state.list[action.index],
    loading: true
  };

  return updateObject(state, {
    list: [...updatedLogsList]
  });
}

function fetchCFRLogsURLSuccess(state, action) {
  const updatedLogsList = [...state.list];
  updatedLogsList[action.index] = {
    ...state.list[action.index],
    loading: false
  };

  return updateObject(state, {
    list: [...updatedLogsList]
  });
}

function fetchCFRLogsURLFailure(state, action) {
  const updatedLogsList = [...state.list];
  updatedLogsList[action.index] = {
    ...state.list[action.index],
    loading: false
  };

  return updateObject(state, {
    list: [...updatedLogsList]
  });
}

function reducer(state = deepClone(initState), action) {
  switch (action.type) {
    case types.FETCH_APP_LOGS_START:
      return fetchAppLogsStart(state, action);
    case types.FETCH_APP_LOGS_SUCCESS:
      return fetchAppLogsSuccess(state, action);
    case types.FETCH_APP_LOGS_FAILURE:
      return fetchAppLogsFailure(state, action);
    case types.FETCH_CFR_LOGS_URL_START:
      return fetchCFRLogsURLStart(state, action);
    case types.FETCH_CFR_LOGS_URL_SUCCESS:
      return fetchCFRLogsURLSuccess(state, action);
    case types.FETCH_CFR_LOGS_URL_FAILURE:
      return fetchCFRLogsURLFailure(state, action);
    default:
      return state;
  }
}

export default reducer;
